export type RechargeGiftCooldownType = 'HOME_POPUP' | 'RECHARGE_ENTRY';

const RECHARGE_GIFT_COOLDOWN_KEYS: Record<RechargeGiftCooldownType, string> = {
  HOME_POPUP: 'recharge-gift:home-popup-cooldown',
  RECHARGE_ENTRY: 'recharge-gift:recharge-entry-cooldown',
};
const DEFAULT_COOLDOWN_HOURS = 24;

interface RechargeGiftCooldownRecord {
  startedAt: number;
}

const getCooldownHours = (cooldownHours?: number | null) =>
  typeof cooldownHours === 'number' && cooldownHours >= 0
    ? cooldownHours
    : DEFAULT_COOLDOWN_HOURS;

export const isRechargeGiftCooldownActive = (
  type: RechargeGiftCooldownType,
  cooldownHours?: number | null,
) => {
  const storageKey = RECHARGE_GIFT_COOLDOWN_KEYS[type];
  const storedValue = localStorage.getItem(storageKey);
  if (!storedValue) {
    return false;
  }
  try {
    const record = JSON.parse(storedValue) as RechargeGiftCooldownRecord;
    if (!Number.isFinite(record.startedAt)) {
      throw new Error('Invalid recharge gift cooldown record');
    }
    const expiresAt =
      record.startedAt + getCooldownHours(cooldownHours) * 60 * 60 * 1000;
    if (expiresAt > Date.now()) {
      return true;
    }
  } catch (_error) {
    // 旧版本只保存结束时间，无法按最新配置重算，直接废弃。
  }
  localStorage.removeItem(storageKey);
  return false;
};

export const startRechargeGiftCooldown = (type: RechargeGiftCooldownType) => {
  const record: RechargeGiftCooldownRecord = {startedAt: Date.now()};
  localStorage.setItem(
    RECHARGE_GIFT_COOLDOWN_KEYS[type],
    JSON.stringify(record),
  );
};

export const clearRechargeGiftCooldown = () => {
  Object.values(RECHARGE_GIFT_COOLDOWN_KEYS).forEach(storageKey => {
    localStorage.removeItem(storageKey);
  });
};
